import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';
import ModalView from './rover_modal';

(document => {
  const blockingModalPubSub = {};
  _.extend(blockingModalPubSub, Backbone.Events);

  function getModalContent(result) {
    if (!result || !result.blocking_modal) {
      return $.Deferred()
        .reject()
        .promise();
    }

    if ($(document.body).hasClass(`js-disable-blocking-modal-${result.blocking_modal.slug}`)) {
      return $.Deferred()
        .reject()
        .promise();
    }

    return $.get(result.blocking_modal.web_url).then(content => ({
      modalContent: content,
      slug: result.blocking_modal.slug,
    }));
  }

  function showModal({ modalContent, slug }) {
    const backboneModal = new ModalView({
      content: modalContent,
      dialogClasses: `modal-blocking-modal modal-blocking-modal-${slug}`,
      disableCancel: true,
      animate: true,
      showFooter: false,
      applyScrollFix: false,
    });
    backboneModal.on('shown', () => {
      blockingModalPubSub.trigger('shown');
    });
    backboneModal.open();

    // and then wait for the acknowledgement
    const d = $.Deferred();
    $(document).on('blocking-modal-acknowledged', () => {
      backboneModal.close();
      d.resolve();
    });

    return d.promise();
  }

  function handleBlockingModal() {
    return $.get(Rover.urls.blockingModalAPI)
      .then(getModalContent)
      .then(showModal);
  }

  function triggerBlockingModalAcknowledged(result) {
    $(document).trigger('blocking-modal-acknowledged');

    // The mobile apps are listening for this event
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.rover &&
      window.webkit.messageHandlers.rover.postMessage
    ) {
      window.webkit.messageHandlers.rover.postMessage({
        action: 'dialog-closed',
      });
    } else {
      $(document).trigger({ type: 'dialog-closed' });
    }

    if (result.redirect_url) {
      window.location.href = result.redirect_url;
    }
  }

  function acknowledgeBlockingModalForm($target) {
    return $.post(
      $target.attr('action'),
      $target.serialize(),
      triggerBlockingModalAcknowledged,
      'json'
    )
      .done(triggerBlockingModalAcknowledged)
      .fail(data => {
        // Don't want anything except the TOS modal to try this
        if (data.responseJSON && data.responseJSON.error) {
          $target
            .find('.error-container')
            .html(`<div class="rover-alert-warn alert">${data.responseJSON.error}</div>`);
        }
      });
  }

  function init() {
    $(document).on('submit', '.js-blocking-modal-acknowledgement-form', event => {
      event.preventDefault();
      acknowledgeBlockingModalForm($(event.target || event.srcElement));
    });
  }

  Rover.blocking_modals = {
    handleBlockingModal,
    pubSub: blockingModalPubSub,
  };
  init();
})(document);



// WEBPACK FOOTER //
// ./js/components/blocking_modals.js